// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__wDn7G","projectList":"Projects_projectList__f8olA","projectCard":"Projects_projectCard__5q3uc"};